module.exports = __webpack_public_path__ + "img/img02@2x(1).842d4bbd.png";